"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = Icon;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

require("./styles/Icon.module.scss");

var styles = {
  "icon": "Icon-module__icon___wi1ik",
  "icon__xxs": "Icon-module__icon__xxs___1pQV5",
  "icon__xs": "Icon-module__icon__xs___bxrle",
  "icon__sm": "Icon-module__icon__sm___19Hp3",
  "icon__md": "Icon-module__icon__md___2eLkz",
  "icon__lg": "Icon-module__icon__lg___BihwY",
  "icon__xl": "Icon-module__icon__xl___2-l4e",
  "icon__xxl": "Icon-module__icon__xxl___2wFfk"
};

function Icon(_ref) {
  var icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["icon", "size", "className"]);

  var SVGElement = icon;
  return _react.default.createElement(SVGElement, _extends({
    className: (0, _classnames.default)(styles.icon, _defineProperty({}, styles["icon__".concat(size)], Boolean(size)), className)
  }, rest));
}